class RouteDTO {

    constructor(id, name) {
        this.id = id;
        this.name = name;
    }

}

export default RouteDTO